import * as Yup from 'yup'
import { ErrorMessage, Form, Formik } from 'formik'
import  {  useEffect, useMemo, useRef, useState } from 'react'
import { ROUTES_PATH } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import Calendar from '../../../components/calendar/Calendar'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import Button from '../../../components/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import {
  convertDateFormatCalendar,
  exportTableWithFooter,
  generateDropdownOptions,
} from '../../../utility/genricFunction'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import './sourceWiseInquiryReport.scss'
import { getCourseFromBranch, getSourceWiseInquiryReport } from '../../../store/builders/reports/reports.builder'
import dayjs from 'dayjs'
import { Row } from 'primereact/row'
import { Column } from 'primereact/column'
import { ColumnGroup } from 'primereact/columngroup'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'


const SourceWiseInquiryReport = () => {
  const dispatch = useDispatch()
  const [showTable, setShowTable] = useState(false)
  const branches = useSelector((state) => state?.branch?.branchTableData)
  const { courseByBranchData: courses, sourceWiseInquiryReportData , loading , pageDropDownLoading } = useSelector((state) => state?.reports)

  const telephonicTotal = sourceWiseInquiryReportData.reduce((acc, data) => {
    return Number(data.telephoniccount) + acc
  }, 0)

  const userRole = useSelector((store) => store?.auth?.user?.result?.userData?.roleName)
    const branchId = useSelector((store) => store?.auth?.user?.result?.userData?.branchId)
  
  const [initialValues] = useState({
    fromDate: '',
    toDate: '',
    branch: userRole == "branch" ? branchId : '',
    course: '',
  })

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
});

  useEffect(()=>{
    if(userRole == "branch"){
      dispatch(getCourseFromBranch(branchId))
    }
  })

  const walkinTotal = sourceWiseInquiryReportData.reduce((acc, data) => {
    acc = Number(data.walkincount) + acc
    return acc
  }, 0)

  const enrollmentTotal = sourceWiseInquiryReportData.reduce((acc, data) => {
    acc = Number(data.enrollcount) + acc
    return acc
  }, 0)

  const t2wTotal = sourceWiseInquiryReportData.reduce((acc, data) => {
    acc = Number(data.t2wcount) + acc
    return acc
  }, 0)

  const courseOption = useMemo(() => generateDropdownOptions(courses, 'courseName', 'courseId'), [courses])
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const breadCrumbsArr = [
    {
      title: 'Source wise inquiry Report',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Source wise inquiry Report',
      link: ROUTES_PATH.SOURCE_WISE_INQUIRY_REPORT,
    },
  ]

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer='Total' colSpan={2} className='table-total-row' />
        <Column footer={telephonicTotal} className='table-total-row' />
        <Column footer={t2wTotal} className='table-total-row' />
        <Column footer={walkinTotal} className='table-total-row' />
        <Column footer={enrollmentTotal} className='table-total-row' />
      </Row>
    </ColumnGroup>
  )

  const columns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      style: { minWidth: '2rem' },
    },
    {
      field: 'inquiry_source_name',
      header: 'Inquiry Source',
      filter: false,
      style: { minWidth: '10rem' },
    },
    {
      field: 'telephoniccount',
      header: 'Telephonic',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '7rem' },
    },
    {
      field: 't2wcount',
      header: 'T2w',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '7rem' },
    },
    {
      field: 'walkincount',
      header: 'Walkin',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '7rem' },
    },
    {
      field: 'enrollcount',
      header: 'Enrollment',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '7rem' },
    },
  ]

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().required('From Date is required').typeError('Invalid Date'),
    toDate: Yup.date()
      .required('To Date is required')
      .typeError('Invalid Date')
      .min(Yup.ref('fromDate'), 'To Date cannot be before From Date'),
    branch: Yup.string().required('Branch is required'),
    course: Yup.string().required('Course is required'),
  })

  const handleBranchDropDownChange = (value, setFieldValue) => {
    setFieldValue('branch', value)
    dispatch(getCourseFromBranch(value))
  }

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> &&  <div className='source-wise-inquiry-report-wrapper'>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(value) => {
          setShowTable(true)
          const data = {
            startDate: dayjs(value.fromDate).format('YYYY-MM-DD'),
            endDate: dayjs(value.toDate).format('YYYY-MM-DD'),
            branchId: value.branch,
            courseId: value.course,
          }
          dispatch(getSourceWiseInquiryReport(data))
        }}
        validationSchema={validationSchema}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <div className='time-table-report-header'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
            <div className='time-table-report-main-div'>
              <div className='time-table-report-input-fields'>
                <Calendar
                  label='From Date'
                  name='fromDate'
                  required={true}
                  width={'25%'}
                  onChange={(values) => {
                    setFieldValue('fromDate', convertDateFormatCalendar(values))
                  }}
                />
                <Calendar
                  label='To Date'
                  name='toDate'
                  required={true}
                  width={'25%'}
                  value={values.toDate}
                  onChange={(values) => {
                    setFieldValue('toDate', convertDateFormatCalendar(values))
                  }}
                />
                <div className='time-table-report-dropdown'>
                  <label htmlFor=''>
                    Branch<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    className={'facultyForm-dropdown'}
                    name={'branch'}
                    placeholder={'Select Branch'}
                    options={branchOption}
                    selectedValue={values.branch}
                    disabled={userRole == "branch"}
                    onChange={(e) => {
                      handleBranchDropDownChange(e.target.value, setFieldValue)
                    }}
                  />
                  <ErrorMessage name='branch' component='div' className='error-msg' />
                </div>
                <div className='time-table-report-dropdown'>
                  <label htmlFor=''>
                    Course<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    className={'facultyForm-dropdown'}
                    name={'course'}
                    placeholder={'Select Course'}
                    options={courseOption}
                    selectedValue={values.course}
                    onChange={handleChange}
                  />
                  <ErrorMessage name='course' component='div' className='error-msg' />
                </div>
              </div>

              <div className='submit-btn-wrapper'>
                <Button type='submit' customClassName={'tt-report-btn-submit'}>
                  Submit
                </Button>
              </div>
            </div>
            {showTable && (
              <div className='source-wise-report-table-div'>
                <div className='export-option-wrapper'>
                  <div className='pdf-excel-export'>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={() =>
                        exportTableWithFooter(
                          sourceWiseInquiryReportData,
                          columns,
                          ['', '', telephonicTotal,t2wTotal, walkinTotal, enrollmentTotal],
                          'Source wise Inquiry Report',
                          'SourceWiseInquiryReport.xlsx',
                        )
                      }
                    >
                      <SimCardDownloadIcon />
                    </Button>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={handleDownloadPfd}
                    ><PrintIcon />
                    </Button>
                  </div>
                </div>

                <div className='printable-component' ref={printRef}>
                <ReportDataTable
                  columns={columns}
                  value={sourceWiseInquiryReportData}
                  footerColumnGroup={footerGroup}
                />
                </div>

                
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>}
    </>
  )
}

export default SourceWiseInquiryReport
